import type { PlaceLocationResult } from './types';

/**
 * Fetches coordinates from Google Maps Places API
 * SSR-safe and mockable for testing
 *
 * @returns Function to fetch location by place ID
 */
export function usePlaceLocation() {
	const { $googleMapsApi } = useNuxtApp();

	/**
	 * Get latitude and longitude for a Google Place ID
	 *
	 * @param placeId - Google Place ID
	 * @returns Object with lat/lng or nulls if unavailable
	 */
	async function getLocation(
		placeId: string | null
	): Promise<PlaceLocationResult> {
		if (!placeId || !$googleMapsApi?.places) {
			return { lat: null, lng: null };
		}

		try {
			const { Place } = $googleMapsApi.places;

			const place = new Place({
				id: placeId
			});

			await place.fetchFields({
				fields: ['location']
			});

			return {
				lat: place.location.lat(),
				lng: place.location.lng()
			};
		} catch (error) {
			console.error('Error fetching place location:', error);
			return { lat: null, lng: null };
		}
	}

	return {
		getLocation
	};
}
